import { Component } from "@angular/core";

@Component({
  templateUrl: "./sample-page.component.html",
  styleUrl: "./sample-page.component.scss",
})
export class SamplePageComponent {}
